// Vendor
import { ElementRef, Renderer2 } from '@angular/core';
import Highcharts from 'highcharts/highstock';
// Constants
import { HIGHCHARTS_PIE_DEFAULT_OPTIONS, NODATA_CLASS, NODATA_DEFAULT_MESSAGE } from './constants';
// Services
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
export class PieChartComponent {
    constructor(ajaxService, eltRef, renderer) {
        this.ajaxService = ajaxService;
        this.eltRef = eltRef;
        this.renderer = renderer;
        this.chartOptions = {};
        this.noDataMessage = NODATA_DEFAULT_MESSAGE;
        this.chartDataUrl = this.eltRef.nativeElement.getAttribute('chartDataUrl');
        const chartDataJson = this.eltRef.nativeElement.getAttribute('chartDataJson');
        if (typeof chartDataJson !== 'undefined' && chartDataJson !== null)
            this.chartData = JSON.parse(chartDataJson);
        const chartOptionsJson = this.eltRef.nativeElement.getAttribute('chartOptionsJson');
        if (typeof chartOptionsJson !== 'undefined' && chartOptionsJson !== null)
            this.chartOptions = JSON.parse(chartOptionsJson);
    }
    ngOnInit() {
        this.highchartOptions = Highcharts.merge(HIGHCHARTS_PIE_DEFAULT_OPTIONS, this.chartOptions);
        this.renderElement = this.eltRef.nativeElement.parentElement;
        if (typeof this.chartDataUrl !== 'undefined' && this.chartDataUrl !== null) {
            this.getChartData(this.chartDataUrl);
        }
        else if (typeof this.chartData !== 'undefined' && this.chartData !== null) {
            this.renderChart(this.chartData);
        }
        else if (typeof this.chartDataJsonInput !== 'undefined' && this.chartDataJsonInput !== null) {
            this.chartData = JSON.parse(this.chartDataJsonInput);
            this.renderChart(this.chartData);
        }
        else {
            this.displayNoData();
        }
    }
    getChartData(chartDataUrl) {
        // Current pie-chart only depends on one ajax call, should consider relocating to separate service
        // if this method finds a cousin
        this.ajaxService.getDataObserveBody(chartDataUrl).subscribe({
            next: (response) => this.renderChart(response.data),
            error: (error) => {
                // If we get an error due to a bad request, write the error message
                if (error.data && error.status === 400) {
                    this.noDataMessage = `<p>${error.data}</p>`;
                }
                else {
                    this.noDataMessage = NODATA_DEFAULT_MESSAGE;
                }
                this.displayNoData();
            },
        });
    }
    renderChart(chartData) {
        const data = chartData.chart_data.map((item) => {
            if ((item.y ?? 0) <= 0) {
                const nulledItem = item;
                nulledItem.y = null;
                return nulledItem;
            }
            return item;
        });
        if (!data) {
            this.displayNoData();
        }
        else {
            this.hideNoData();
            this.highchartOptions.series[0].data = data;
            new Highcharts.Chart(this.renderElement, this.highchartOptions); // eslint-disable-line no-new
        }
    }
    displayNoData() {
        // Remove chartData so that if the chart wasn't cleaned up nicely,
        // it doesn't reappear
        this.renderer.addClass(this.eltRef.nativeElement, NODATA_CLASS);
        this.renderer.setProperty(this.eltRef.nativeElement, 'innerHTML', this.noDataMessage);
    }
    hideNoData() {
        this.renderer.removeClass(this.eltRef.nativeElement, NODATA_CLASS);
        this.renderer.setProperty(this.eltRef.nativeElement, 'innerHTML', '');
    }
}
PieChartComponent.ɵfac = function PieChartComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PieChartComponent)(i0.ɵɵdirectiveInject(i1.AjaxService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2)); };
PieChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PieChartComponent, selectors: [["ycn-pie-chart"]], inputs: { chartDataJsonInput: "chartDataJsonInput" }, standalone: false, decls: 0, vars: 0, template: function PieChartComponent_Template(rf, ctx) { }, encapsulation: 2 });
